<script setup>
import LIcon from "@/components/shared/LIcon.vue";
import { useUiStore } from "@/stores/ui";

const uiStore = useUiStore();

const props = defineProps({
  data: Object,
});

const action = (type, data) => {
  uiStore.setModalAction(type);
  uiStore.setModalState(true);
  uiStore.setModalData(data);
};
</script>

<template>
  <div class="actions-cell">
    <button @click="action('edit_theme_assignment', props.data)" type="button" class="icon-button" title="Edit">
      <LIcon name="pencil" />
    </button>
    <button @click="action('activate_theme_assignment', props.data)" type="button" class="icon-button" :title="props.data.status == 'active' ? 'Deactivate Assignment' : 'Activate Assignment'">
      <LIcon v-if="props.data.status == 'active'" name="toggle-right" class="success-color" />
      <LIcon v-else name="toggle-left" />
    </button>
    <button @click="action('delete_theme_assignment', props.data)" type="button" class="icon-button danger" title="Delete">
      <LIcon name="trash-2" />
    </button>
  </div>
</template>
